import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Header from './Header';
import TextSection from './TextSection';

const PageWrapper = styled.div`
	min-height: 100vh;
	display: grid;
	align-content: space-between;
`;

class SubPage extends PureComponent {
	componentDidMount() {
		window.scrollTo(0, 0);
	}

	render() {
		const { heading, text } = this.props;

		return (
			<PageWrapper>
				<Header heading={heading} />
				<TextSection input={text} />
			</PageWrapper>
		);
	}
}

SubPage.propTypes = {
	heading: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired
};

export default SubPage;



// WEBPACK FOOTER //
// ./src/components/SubPage.js